import { useEffect } from 'react'
import { dispatchTag } from '../../store/analytics/analytics.actions'
import { useAction } from '../utils/react-redux'

const useImpressionTag = (condition, { type, tagInfo }) => {
  const execDispatchTag = useAction(dispatchTag)

  useEffect(() => {
    if (condition) {
      execDispatchTag({
        type,
        tagInfo,
        isImpression: true
      })
    }
  }, [condition])
}

export default useImpressionTag
